import * as types from "./actionTypes";

export const fetchAttendanceRequest = (params) => ({
  type: types.FETCH_ATTENDANCE_REQUEST,
  payload: params,
});

export const fetchAttendanceSuccess = (data) => ({
  type: types.FETCH_ATTENDANCE_SUCCESS,
  payload: data,
});

export const fetchAttendanceFailure = (error) => ({
  type: types.FETCH_ATTENDANCE_FAILURE,
  payload: error,
});
